export default __webpack_public_path__ + "static/media/artmedica3.e08010cf.png";